export default {
  name: '',
  code: '',
  type: 'sensor',
  imageUrl: null,
  eventTypes: [],
  modelReadingTypes: [],
}
